import { render, staticRenderFns } from "./FitmentMarketAnalysisList.vue?vue&type=template&id=a2c82038&scoped=true&"
import script from "./FitmentMarketAnalysisList.vue?vue&type=script&lang=js&"
export * from "./FitmentMarketAnalysisList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c82038",
  null
  
)

export default component.exports